module.exports = __webpack_public_path__ + "media/images/cooling-solution-366555851149e6ccc367f957f593f7e0.svg";